module.exports = __webpack_public_path__ + "static/media/wind-power.a2808f1b.svg";